import { Directive, ElementRef, HostListener, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SegmentService } from 'app/shared/services';

@Directive({
    selector: '[zoom]',
    standalone: false
})
export class ZoomDirective implements OnChanges {
    @Input() image: string;
    @Input() zoom: boolean;

    private hoverTimeout: NodeJS.Timeout;
    private readonly trackTimer = 3000;

    constructor(
        private element: ElementRef<HTMLDivElement>,
        private segmentService: SegmentService,
        private router: Router
    ) {
        const styles = `
            height: 100%;
            width: 100%;

            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        `;

        this.element.nativeElement.setAttribute('style', styles);
    }

    ngOnChanges(): void {
        if (this.image) {
            this.element.nativeElement.style.backgroundImage = `url(${this.image})`;
        }
    }

    @HostListener('mousemove', ['$event']) handleMouseMove(event: MouseEvent) {
        if (this.zoom) {
            const element = event.currentTarget as HTMLDivElement;

            const relativeXOffset = (event.offsetX / element.offsetWidth) * 100;
            const relativeYOffset = (event.offsetY / element.offsetHeight) * 100;
            element.style.backgroundPosition = `${relativeXOffset}% ${relativeYOffset}%`;
        }
    }

    @HostListener('mouseenter') handleMouseEnter() {
        if (this.zoom) {
            this.hoverTimeout = setTimeout(this.trackHover, this.trackTimer);

            this.element.nativeElement.style.backgroundSize = '200%';
            this.element.nativeElement.style.cursor = 'zoom-in';
        }
    }

    @HostListener('mouseleave') handleMouseLeave() {
        if (this.zoom) {
            clearTimeout(this.hoverTimeout);

            this.element.nativeElement.style.backgroundSize = 'contain';
            this.element.nativeElement.style.cursor = 'default';
            this.element.nativeElement.style.backgroundPosition = `center`;
        }
    }

    private trackHover() {
        const prefix = this.router.url.includes('/preorder/') ? '[Pre]' : '[Re]';
        this.segmentService.track(`${prefix} uses hover zoom-in`);
    }
}
